import {Box} from "@mui/material";
import {Theme} from "@mui/material/styles";
import ImageGallery from "react-image-gallery";
import React from "react";
import {useResizeHook} from "@/lib";
import {Category, CategoryDetails} from "@/types";

const CategoryHighlightsGallery = ({category, disableSwipe = true}: {
    category: CategoryDetails & Category,
    disableSwipe?: boolean
}) => {

    const {lessThanTablet} = useResizeHook();

    return (<Box sx={(theme: Theme) => ({
        overflow: 'hidden',
        justifyItems: 'center',
        [theme.breakpoints.down('md')]: {
            borderTopRightRadius: '10px',
            borderTopLeftRadius: '10px',
        },
        [theme.breakpoints.down('lg')]: {
            padding:1,
        },
        '.image-gallery-slide-wrapper': {
            pointerEvents: disableSwipe ? 'none' : 'inherit',
        },
        '.image-gallery-left-nav, .image-gallery-right-nav': {
            pointerEvents: 'auto', // Ensure arrows remain clickable
        },
    })}>
        {!!category.images?.length && <ImageGallery
            items={category.images}
            showThumbnails={!!category.images.length > 1}
            thumbnailPosition={!!category.images.length > 1 ? 'left' : undefined}
            showBullets={true}
            showNav={!lessThanTablet}
            showPlayButton={false}
            showFullscreenButton={!lessThanTablet}
            disableSwipe={disableSwipe}
            autoPlay={true}
            slideInterval={2000}  // time in milliseconds between slides
        />}
    </Box>)
}

export default CategoryHighlightsGallery;
